export class ShiftPatternEntry {
  offset: number;
  startHour: number;
  startMinute: number;
  duration: number;
}
